import { gql } from '@apollo/client';
import { userFragment } from './fragments';

export const meWithTutorialQuery = gql`
  query MeWithTutorialQuery($activeTrainingsOnly: Boolean) {
    me {
      ...BasicUserInfo
      attendees(activeTrainingsOnly: $activeTrainingsOnly) {
        trainingType
        invitedAt
        completedAt
        trainingName
        trainingDeadline
      }
      tutorial {
        finished
        closed
        game {
          id
          status
        }
      }
      company {
        name
        layoutTutorialSceneName
        layout {
          code
        }
        isActiveTraining
      }
    }
  }
  ${userFragment}
`;

export const meQuery = gql`
  query Me {
    me {
      ...BasicUserInfo
    }
  }
  ${userFragment}
`;

export const cardDefenseQuery = gql`
  query defenseQuery($sceneId: ID!, $playerCardId: ID!, $hackerCardId: ID!) {
    defense(
      sceneId: $sceneId
      playerCardId: $playerCardId
      hackerCardId: $hackerCardId
    ) {
      text
      link
      linkText
    }
  }
`;

export const languagesQuery = gql`
  query LanguagesQuery {
    languages {
      code
      name
    }
  }
`;

export const gameStatsQuery = gql`
  query GameStatsQuery($id: ID!) {
    game(id: $id) {
      id
      stats {
        defenses {
          opportunities
          played
        }
        threats {
          selfBurns
          avoidableSelfBurns
        }
      }
    }
  }
`;

export const meWithCompanyTranslationsQuery = gql`
  query MeWithCompanyTranslationsQuery($languageCode: String!) {
    me {
      company {
        welcomeTranslations(languageCode: $languageCode) {
          languageCode
          title
          subtitle
          text
        }
        gdprTranslations(languageCode: $languageCode) {
          languageCode
          text
        }
      }
    }
  }
`;

export const meWithNotificationQuery = gql`
  query MeWithNotificationQuery {
    me {
      id
      UnconfirmedNotifications {
        id
        type
        translation {
          languageCode
          imageLink
        }
      }
    }
  }
`;

export const setNotificationConfirmedMutation = gql`
  mutation SetNotificationConfirmedMutation(
    $input: SetNotificationConfirmedInput!
  ) {
    setNotificationConfirmed(input: $input) {
      id
      hasUnconfirmedNotification
    }
  }
`;

export const closeTutorialGameMutation = gql`
  mutation CloseTutorialGame {
    closeTutorialGame
  }
`;

export const startGameMutation = gql`
  mutation StartGame($input: StartGameInput!) {
    startGame(input: $input)
  }
`;
